<div class="flex flex-column gap-3 md:w-20rem">
  <h3 class="m-0"
      i18n>Topic list</h3>

  @if (hintText) {
    <span class="text-color-secondary">{{ hintText }}</span>
  }

  @if ((topics$ | async); as topics) {
    <div class="flex flex-column gap-3">
      @for (topic of topics; track topic.heading) {
        <div class="flex align-items-center">
          <p-checkbox name="topics"
                      [value]="topic.heading"
                      [ngModel]="selected"
                      (ngModelChange)="onSelectedChange($event)"
                      [disabled]="disabled"
                      [inputId]="'topic-' + topic.order">
          </p-checkbox>
          <label [for]="'topic-' + topic.order"
                 class="ml-2">{{ topic.heading }}</label>
        </div>
      }
    </div>
  }
</div>